module.exports = __webpack_public_path__ + "img/gender.ae0c533c.svg";